import { Injectable, HostListener } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MyInterestService } from './my-interest.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private subject = new Subject<any>();
  private profileImage = new BehaviorSubject<any>(null);
  private sidebar = new BehaviorSubject<any>(null);
  private profileConnectionCount = new BehaviorSubject<any>(null);
  private setMyConnections = new BehaviorSubject<any>(null);
  private uploadingQueue = new BehaviorSubject<any>(null);
  public ngSubscribe = new BehaviorSubject<any>(null);
  public ngUnsubscribe = new BehaviorSubject<any>(null);
  public subscriberCountObj = new BehaviorSubject<any>(null);

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) {
  }

  modalOpen(componentModal, size, center, type?, token?, paramID?) {
    this.subject.next({ componentModal, size, center, type, token, paramID });
  }

  modalGet(): Observable<any> {
    return this.subject.asObservable();
  }

  login(userData) {
    return this.http
      .post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.API.AUTH.LOGIN, userData, { observe: 'response' })
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  revokeFacebookAccess(id,token){
    return this.http.delete(`https://graph.facebook.com/${id}/permissions?access_token=${token}`)
  }

  getUserPermissions() {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.PERMISSION);
  }

  signUp(userData) {
    return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.API.AUTH.SIGN_UP, userData);
  }

  logOut() {
    let userData = this.getCurrentUser();
    let _appId = localStorage.getItem('_appId');
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.DEVICES + API_ENDPOINTS.DELETE_DEVICES + '?device[device_id]=' + _appId + '&device[plateform]=web&device[user_id]=' + userData.user.id);
  }

  clearStorage() {
    sessionStorage.clear();
    localStorage.clear();
  }

  isSupplementaryAccount() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (currentUser && currentUser.user && currentUser.user.user_account_type === 'supplementary') {
      return true;
    }
    return false;
  }

  isLoggednIn() {
    let rememberMe = localStorage.getItem('rememberMe');

    let currentUser;

    if (rememberMe == 'true') {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
    else {
      currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    }
    if (currentUser)
      return true;
    else
      return false;
  }



  getCurrentUser() {

    let userData;
    if (window.localStorage.getItem('rememberMe') == 'true') {
      userData = JSON.parse(window.localStorage.getItem('currentUser'));
    }
    else {
      userData = JSON.parse(window.sessionStorage.getItem('currentUser'));
    }
    return userData;
  }

  confirmUser(token) {
    const paramObj = {
      confirmation_token: token,
    }
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.API.AUTH.CONFIRMATION, paramObj, true);
  }

  createNotification(params) {
    return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.DEVICES, params);
  }

  editUserProfile(userId, userData, userType) {

    const formData = new FormData();
    Object.entries(userData.user).forEach(([key, value]) => {

      if (key !== 'locations_attributes') {
        formData.set(`user[${key}]`, value as string);
      } else {
        Object.entries(userData.user['locations_attributes'][0]).forEach(([k, v]) => {
          if (v)
            formData.set(`user[${key}][0]${k}`, v.toString() as string);
          else if (k == 'id')
            formData.set(`user[${key}][0]${k}`, v as string);
          else
            formData.set(`user[${key}][0]${k}`, '');
        });
      }
    });
    if (userType == 'business' || userType == 'businessRequestVerification') {
      Object.entries(userData.user_business).forEach(([key, value]) => {
        if (value)
          formData.set(`user_business[${key}]`, value.toString() as string);
        else
          formData.set(`user_business[${key}]`, value as string);
      });
    }

    return this.apiService.patch(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + '/' + userId, formData);
  }

  confirmAndEditUserProfile(userData, userType) {

    const formData = new FormData();
    Object.entries(userData.user).forEach(([key, value]) => {
      // console.log(key);

      if (key !== 'locations_attributes') {

        if(key === 'confirmation_token'){
          formData.set(`${key}`, value as string);
        } else {
          formData.set(`user[${key}]`, value as string);
        }
      }  else
        {
        Object.entries(userData.user['locations_attributes'][0]).forEach(([k, v]) => {
          if (v)
            formData.set(`user[${key}][0]${k}`, v.toString() as string);
          else if (k == 'id')
            formData.set(`user[${key}][0]${k}`, v as string);
          else
            formData.set(`user[${key}][0]${k}`, '');
        });
      }
    });
    if (userType == 'business' || userType == 'businessRequestVerification') {
      Object.entries(userData.user_business).forEach(([key, value]) => {
        if (value)
          formData.set(`user_business[${key}]`, value.toString() as string);
        else
          formData.set(`user_business[${key}]`, value as string);
      });
    }

    return this.apiService.put(API_ENDPOINTS.BASE_URL  + API_ENDPOINTS.API.CONFIRM_AND_UPDATE , formData, true);
  }

  verificationOfUser(verifyUserData) {

    const formData = new FormData();

    Object.entries(verifyUserData.verificationData.verification).forEach(([key, value]) => {
      formData.set(`verification[${key}]`, value as string);
    });

    return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.BUSINESS_PROFILE + API_ENDPOINTS.API.USER_REQUEST_VERIFICATION, formData);
  }

  editUserProfileOnSignUp(userId, userData) {

    const formData = new FormData();
    Object.entries(userData.user).forEach(([key, value]) => {

      if (key !== 'locations_attributes') {
        formData.set(`user[${key}]`, value as string);
      } else {
        Object.entries(userData.user['locations_attributes'][0]).forEach(([k, v]) => {
          formData.set(`user[${key}][0]${k}`, v.toString() as string);
        });
      }
    });

    return this.http
      .patch(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + '/' + userId, formData, { observe: 'response' })
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  forgotPassword(userData) {
    return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.API.AUTH.PASSWORD, userData);
  }

  resetPassword(userData) {
    return this.apiService.patch(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.API.AUTH.PASSWORD, userData);
  }

  setHeader() {
    this.profileImage.next(true);
  }

  loadHeader(): Observable<any> {
    return this.profileImage.asObservable();
  }

  setConnectionCounts(countObj) {
    this.subscriberCountObj.next(countObj);
  }

  loadConnectionCounts(): Observable<any> {
    return this.subscriberCountObj.asObservable();
  }

  setSidebar() {
    this.sidebar.next(true);
  }

  loadSidebar(): Observable<any> {
    return this.sidebar.asObservable();
  }

  setProfileCount() {
    this.profileConnectionCount.next(true);
  }

  loadProfileCount(): Observable<any> {
    return this.profileConnectionCount.asObservable();
  }

  setMyConnection() {
    this.setMyConnections.next(true);
  }

  loadMyConneciton(): Observable<any> {
    return this.setMyConnections.asObservable();
  }

  getCurrentUserData(userId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + '/' + userId);
  }

  checkConfirmToken(userToken) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.USER_CONFIRMED + '?token=' + userToken);
  }
  checkResetToken(userToken, userID) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.VALID_RESET_TOKEN + '?reset_password_token=' + userToken + '&id=' + userID);
  }

  updateCoverProfileImage(userId, params) {

    const formData = new FormData();
    formData.set(`user[cover]`, params as string);

    return this.apiService.put(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.USERS + '/' + userId +
      API_ENDPOINTS.API.UPDATE_COVER, formData);
  }

  updateProfileImage(userId, params) {
    const formData = new FormData();
    formData.set(`user[avatar]`, params as string);

    return this.apiService.put(
      API_ENDPOINTS.BASE_URL +
      API_ENDPOINTS.VERSION +
      API_ENDPOINTS.API.USERS + '/' + userId +
      API_ENDPOINTS.API.UPDATE_AVATAR, formData);
  }

  completedProfilePersentage() {
    const user = this.getCurrentUser();
    let missing = [];
    if (user.user && user.user.business_profile) {
      const paramArray = ['name', 'email', 'status', 'avatar', 'cover'];
      const labelParams = {
        name: 'Name',
        email: 'Email',
        status: 'Account type',
        avatar: 'Profile picture',
        cover: 'Profile cover',
        category: 'Category'
      };
      // const paramArray_business = ['name', 'verification_proof_no', 'business_address', 'industry_id', 'about', 'photo_id_proof'];
      const paramArray_business = ['name', 'industry_id', 'about', 'business_address'];
      const labelBusiness = {
        name: "Business name",
        verification_proof_no: "Business license or similar",
        business_address: "Business address",
        industry_id: "Industry",
        about: "About business",
        photo_id_proof: "Business Document"
      }
      const total = paramArray_business.length + paramArray.length + 2;// 1 for interest //1 fpr location
      let completed = 0;
      if (window.localStorage.getItem('currentUserInterestSelected') == 'true') {
        completed += 1;
      } else {
        missing.push('Interests');
      }
      paramArray.forEach((element) => {
        if (user['user'][element] !== null && user['user'][element] !== undefined && user['user'][element] !== '' && user['user'][element]) {
          completed = completed + 1;
        } else {
          missing.push(labelParams[element]);
        }
      });
      paramArray_business.forEach((element) => {
        if (user.user.business_profile[0][element] !== null && user.user.business_profile[0][element] !== undefined && user.user.business_profile[0][element] !== '' && user.user.business_profile[0][element]) {
          completed = completed + 1;
        } else {
          missing.push(labelBusiness[element]);
        }
      });
      if (user.user && user.user.locations) {
        if (user.user.locations.country != '' && user.user.locations.country != undefined && user.user.locations.country) {
          completed = completed + 1;
        } else {
          missing.push('Country');
        }
      }
      if (completed != 0) {
        return [Math.round((completed / total) * 100), missing];
      } else {
        return false;
      }
    } else {
      const paramArray = ['name', 'status', 'email', 'birth_date', 'avatar', 'cover', 'category', 'about'];
      const labelParams = {
        name: "Name",
        status: "Account type",
        email: "Email",
        birth_date: "Birth date",
        avatar: 'Profile picture',
        cover: 'Profile cover',
        category: 'Category',
        about: "About you"
      }
      const total = paramArray.length + 2; // 1 for interest //1 fpr location
      let completed = 0;
      if (window.localStorage.getItem('currentUserInterestSelected') == 'true') {
        completed += 1;
      } else {
        missing.push('Interests');
      }
      paramArray.forEach((element) => {
        if (user['user'][element] !== null && user['user'][element] !== undefined && user['user'][element] !== '' && user['user'][element]) {
          completed = completed + 1;
        } else {
          missing.push(labelParams[element]);
        }
      });
      if (user.user && user.user.locations) {
        if (user.user.locations.country != '' && user.user.locations.country != undefined && user.user.locations.country) {
          completed = completed + 1;
        } else {
          missing.push('Country');
        }
      }
      if (completed != 0) {
        return [Math.round((completed / total) * 100), missing];
      } else {
        return false;
      }
    }
  }

  setUploadingQueue(data) {
    this.uploadingQueue.next(data);
  }

  getUploadingQueue(): Observable<any> {
    return this.uploadingQueue.asObservable();
  }

  getSequenceFile(): Observable<any> {
    return this.ngSubscribe.asObservable();
  }

  cancelUploadingFileDetect(data) {
    this.ngUnsubscribe.next(data);
  }

  // afterCancellingUpload(data) {
  //   return this.apiService.post(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENTS + API_ENDPOINTS.API.DELETE_CANCELLED_UPLOAD, data);
  // }

  cancelUploadingFile(): Observable<any> {
    return this.ngUnsubscribe.asObservable();
  }

  signInWithLinkedIN() {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.API.AUTH.AUTH + API_ENDPOINTS.API.AUTH.LINKEDIN);
  }
}
